import CONFIG from '@/config/index.js';
// #ifdef APP-PLUS
import { debuggerModule } from '../uni_modules/imengyu-IMDebuggerWindow/common/debuggerExtern.js';
// #endif

function log(...args) {
  console.log(...args);
  addLog(args, 'log');
}

function addLog(args, type = 'log') {
  // #ifdef APP-PLUS
  CONFIG.isDebugger &&
    debuggerModule.addLog({
      type,
      objects: args,
    });
  // #endif
}

export const Logger = {
  log,
};
